import { buildStepNarration } from './stepNarrationCopy.js'

export const ACME_INSURANCE_RENEWAL_DEMO_USER_PROMPT =
  'Create a customer brief for our Acme Insurance renewal meeting tomorrow'

export const ACME_INSURANCE_RENEWAL_DEMO_THOUGHT_DETAILS = [
  `The user needs a customer brief for tomorrow's Acme Insurance renewal meeting. I should pull the latest account context from CRM, recent email threads, and customer success notes before drafting anything.`,
  `HubSpot shows the renewal at **$185,000** in Contract Review with Commit forecast. Adoption is strong at 82% seat activation, but security is still waiting on SSO enforcement timing and the retention addendum status.`,
  `The account team has a clear champion in Maya Chen and an executive sponsor in Dana Kim, but Dana has missed the last two working sessions. I'll structure the brief around stakeholders, meeting agenda, and a 24-hour follow-up plan.`,
]

export const ACME_INSURANCE_RENEWAL_DEMO_WORKFLOW_STEPS = [
  {
    durationMs: 2200,
    actionName: 'Search HubSpot for Acme Insurance account records',
    arguments: { company: 'Acme Insurance', objects: ['company', 'deal', 'contacts', 'activities'] },
    result: { ok: true, dealValue: 185000, stage: 'Contract Review', adoption: '82%' },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Account snapshot loaded — renewal on track with open security items',
      'reviewing recent Gmail threads with Acme Insurance',
      0,
    ),
  },
  {
    durationMs: 2000,
    actionName: 'Review recent Gmail threads with Acme Insurance',
    arguments: { threads: 6, topics: ['SSO enforcement', 'retention addendum', 'finance analytics'] },
    result: { ok: true, blockers: ['SSO date unconfirmed'], expansionSignal: 'executive dashboard for finance' },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Stakeholder signals and procurement blockers identified',
      'drafting the renewal brief artifact',
      1,
    ),
  },
  {
    durationMs: 1800,
    actionName: 'Draft Acme Insurance Renewal Brief',
    arguments: { format: 'markdown', sections: ['executive summary', 'stakeholder map', 'meeting plan'] },
    result: { ok: true, fileName: 'Acme Insurance renewal brief.md' },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Renewal brief drafted with agenda, questions, and follow-up plan',
      'summarizing key highlights for the chat response',
      2,
    ),
  },
]
